import { Component, createRef } from 'react';
import { Link } from 'react-router';
import { NumericFormat } from 'react-number-format';
import CountryList from 'country-list-with-dial-code-and-flag';
import CountryFlagSvg from 'country-list-with-dial-code-and-flag/dist/flag-svg';
import { Tooltip } from 'react-tooltip';
import makeCancellablePromise from 'make-cancellable-promise';
import { addDoc, collection } from 'firebase/firestore';
import { toast } from 'react-toastify';
import Popup from 'reactjs-popup';
import parsePhoneNumber, { isPossiblePhoneNumber, isValidPhoneNumber, validatePhoneNumberLength } from 'libphonenumber-js';

import withRouter from './../../helper/withrouter';
import { db } from './../../helper/firebase.js';
import FormInput from './../../components/FormInput.js';
import FormSelect from './../../components/FormSelect.js';
import { ReactComponent as LogoTsNormal } from './../../assets/img/tabsquare.svg';
import { ReactComponent as LogoTsWhite } from './../../assets/img/tabsquare-white.svg';
import { ReactComponent as IconCheck } from './../../assets/img/icon-check.svg';
import { ReactComponent as IconInfo } from './../../assets/img/icon-info.svg';
import { ReactComponent as IconPlus } from './../../assets/img/icon-plus.svg';
import { ReactComponent as IconChev } from './../../assets/img/icon-chevron.svg';

class Homepage extends Component{
  constructor(){
    super();
    
    this.state = {
      load: false,
      faq: [{
        question: 'Can I get a free trial?',
        answer: 'We’re offering free trial packages, you can start with Starting Out Plan, then you can lunch your merchant',
        open: false
      }, {
        question: 'Can I get a free trial?',
        answer: 'Answer for "<strong>Can I get a free trial?</strong>" question.',
        open: false
      }, {
        question: 'What forms of payment do you accept?',
        answer: 'Answer for "<strong>What forms of payment do you accept?</strong>" question.',
        open: false
      }, {
        question: 'Can I cancel my subscription?',
        answer: 'Answer for "<strong>Can I cancel my subscription?</strong>" question.',
        open: false
      }, {
        question: 'How do I switch from a Pro plan to a Team plan?',
        answer: 'Answer for "<strong>How do I switch from a Pro plan to a Team plan?</strong>" question.',
        open: false
      }, {
        question: 'What is the difference between Enterprise plan and Team plan?',
        answer: 'Answer for "<strong>What is the difference between Enterprise plan and Team plan?</strong>" question.',
        open: false
      }, {
        question: 'What is your refund policy?',
        answer: 'Answer for "<strong>What is your refund policy?</strong>" question.',
        open: false
      }],
      region: '',
      height: {
        card: '',
        suggest: ''
      },
      compare: [],
      compareOpen: false,
      compareFloating: false,
      popOpen: '',
      name: '',
      nameInit: false,
      nameValid: 'Name cannot be empty.',
      email: '',
      emailInit: false,
      emailValid: 'Email cannot be empty.',
      code: '',
      codeOption: [],
      phone: '',
      phoneInit: '',
      phoneValid: 'Phone number cannot be empty.',
      phoneFull: '',
      restaurant: '',
      restaurantInit: false,
      restaurantValid: 'Restaurant name cannot be empty.',
      country: '',
      agree: false,
      agreeInit: '',
      agreeValid: 'You must agree to the Privacy Policy and consent to TabSquare using your information before submitting the form.',
      formValid: false,
      formLoad: false,
      formSuccess: false,
      pipedriveCountry: '',
      header: true,
      nav: false
    }
    
    this.country = [{
      label: 'Singapore',
      value: 'SG',
      flag: CountryFlagSvg['SG'],
      status: true
    }, {
      label: 'Malaysia',
      value: 'MY',
      flag: CountryFlagSvg['MY'],
      status: true
    }, {
      label: 'Australia',
      value: 'AU',
      flag: CountryFlagSvg['AU'],
      status: false
    }, {
      label: 'Indonesia',
      value: 'ID',
      flag: CountryFlagSvg['ID'],
      status: true
    }, {
      label: 'Taiwan',
      value: 'TW',
      flag: CountryFlagSvg['TW'],
      status: false
    }, {
      label: 'Hongkong',
      value: 'HK',
      flag: CountryFlagSvg['HK'],
      status: false
    }, {
      label: 'Thailand',
      value: 'TH',
      flag: CountryFlagSvg['TH'],
      status: false
    }, {
      label: 'Philippines',
      value: 'PH',
      flag: CountryFlagSvg['PH'],
      status: false
    }, {
      label: 'UAE',
      value: 'AE',
      flag: CountryFlagSvg['AE'],
      status: false
    }, {
      label: 'Sweden',
      value: 'SE',
      flag: CountryFlagSvg['SE'],
      status: false
    }, {
      label: 'New Zealand',
      value: 'NZ',
      flag: CountryFlagSvg['NZ'],
      status: false
    }, {
      label: 'Brunei',
      value: 'BN',
      flag: CountryFlagSvg['BN'],
      status: false
    }];

    this.region = [{
      name: 'SG',
      fullName: 'Singapore',
      flag: CountryFlagSvg['SG'],
      thousand: ',',
      decimal: '.',
      currency: 'SGD',
      scale: 0,
      fixed: true,
      lang: {
        // page: 'PRICING',
        title: 'Flexible Plans to Grow Your Restaurant',
        subtitle: 'Choose the right digital solution for your business from starting small to managing a large, multi-brand empire.',
        month: 'month',
        location: 'Location',
        start: 'Get Started',
        contact: 'Talk to Our Team',
        best: 'Best Value'
      },
      pricing: [{
        id: 1,
        name: 'Starting Out',
        slug: 'starting_out',
        pipedriveId: '84954280-dcae-11f0-9e2f-69f262634e8f',
        suggest: 'Suggested for 1-3 outlets',
        desc: 'Ideal for independent merchants who want to start taking QR orders today - no complexity, just results',
        feature: [{
          name: '',
          desc: ''
        }, {
          name: 'No POS required',
          desc: ''
        }, {
          name: 'Standard QR ordering',
          desc: ''
        }, {
          name: 'Payments integration',
          desc: ''
        }, {
          name: 'Simple daily reports',
          desc: ''
        }, {
          name: 'Low transaction fees',
          desc: ''
        }],
        highlight: false,
        disc: '',
        price: 0,
        form: false,
        open: false,
        compare: [[true, true, false, false, false], [true, false, false], [false, false, false, false, ''], [true, false, false], [true, false, false], [true, false, false]]
      }, {
        id: 2,
        name: 'Growing Hot',
        slug: 'growing_hot',
        pipedriveId: '6f461710-dcae-11f0-9f27-b96faef5ae67',
        suggest: 'Suggested for 4-10 outlets',
        desc: 'Ideal for independent merchants who want to start taking QR orders today - no complexity, just results',
        feature: [{
          name: 'Everything in Starting Out',
          desc: ''
        }, {
          name: 'Send orders to POS',
          desc: ''
        }, {
          name: 'Increase avg bill value with AI',
          desc: ''
        }, {
          name: 'Integrate delivery partners',
          desc: ''
        }, {
          name: 'Outlets level insights',
          desc: ''
        }, {
          name: 'Lowest transaction fees',
          desc: ''
        }],
        highlight: true,
        disc: '',
        price: 49,
        form: false,
        open: false,
        // compare: [[true, true, false, false, false], [true, true, false], [true, false, false, false, 'Order'], [true, true, true], [true, true, false], [{name: 'Tabsquare Console', img: require(`./../../assets/img/compare.webp`)}, {name: 'Tabsquare Console', img: require(`./../../assets/img/compare.webp`)}]]
        compare: [[true, true, false, false, false], [true, true, false], [true, false, false, false, 'Order'], [true, true, true], [true, true, false], [true, true, false]]
      }, {
        id: 3,
        name: 'Scaling Up',
        slug: '',
        pipedriveId: '4a9c4520-d66d-11f0-a9eb-0d438a1dd28a',
        suggest: 'Suggested for 11-30 outlets',
        desc: 'Ideal for ambitious F&B brands building loyal communities and maximizing customer interaction',
        feature: [{
          name: 'Everything in Growing Hot',
          desc: ''
        }, {
          name: 'Sync menu changes from POS',
          desc: ''
        }, {
          name: 'Next generation QR ordering',
          desc: ''
        }, {
          name: 'Handle menu at brand level',
          desc: ''
        }, {
          name: 'Customer level insights',
          desc: ''
        }, {
          name: 'Low transaction fees',
          desc: ''
        }],
        highlight: false,
        disc: '',
        price: 149,
        form: true,
        open: false,
        compare: [[true, true, true, true, true], [true, true, true], [true, true, false, false, 'Order + Menu'], [true, true, true], [true, true, true], [true, true, false]]
      }, {
        id: 4,
        name: 'Industry Leader',
        slug: '',
        pipedriveId: '46dcc800-d5b0-11f0-b3de-438e29274cf2',
        suggest: 'Suggested for 30+ outlets',
        desc: 'Ideal for enterprise groups and multi-location brands requiring deep integrations and custom workflows',
        feature: [{
          name: 'Everything in Scaling Up',
          desc: ''
        }, {
          name: 'Custom Integration with POS',
          desc: ''
        }, {
          name: 'Custom 3rd Party CRM Integration',
          desc: ''
        }, {
          name: 'Optimised Operations Workflow',
          desc: ''
        }, {
          name: '99.9% Uptime',
          desc: ''
        }, {
          name: 'Scale with Dedicated Account Manager',
          desc: ''
        }],
        highlight: false,
        disc: '',
        price: '',
        form: true,
        open: false,
        compare: [[true, true, true, true, true], [true, true, true], [true, true, true, true, 'Order + Menu'], [true, true, true], [true, true, true], [true, true, true]]
      }]
    }
    // , {
    //   name: 'ID',
      // fullName: 'Indonesia',
    //   flag: CountryFlagSvg['ID'],
    //   thousand: '.',
    //   decimal: ',',
    //   currency: 'IDR',
    //   scale: 0,
    //   fixed: false,
    //   lang: {
    //     //page: 'HARGA',
    //     title: 'Nilai yang Tumbuh Bersama Anda.',
    //     subtitle: 'Temukan paket harga yang dirancang untuk setiap tahap perjalanan restoran Anda, dari pesanan pertama hingga kesuksesan penuh.',
    //     month: 'Bulan',
    //     location: 'Toko',
    //     start: 'Mulai',
    //     contact: 'Hubungi Tim Kami',
    //     best: 'Paling Populer'
    //   },
    //   pricing: [{
    //     id: 1,
    //     name: 'LaunchAI',
    //     suggest: '',
    //     desc: 'Langsung Aktif. Tanpa Ribet.',
    //     feature: [{
    //       name: 'Pendaftaran Mandiri',
    //       desc: 'Mulai dengan cepat melalui proses setup yang mudah dan terarah—tanpa perlu bantuan teknis.'
    //     }, {
    //       name: 'Pemesanan & Pembayaran QR Mandiri',
    //       desc: 'Biarkan pelanggan memesan dan membayar langsung lewat kode QR, tanpa perlu terhubung ke POS.'
    //     }, {
    //       name: 'Tanpa AI Booster',
    //       desc: 'Paket ini tidak mencakup fitur berbasis AI seperti promosi otomatis atau peningkatan penjualan.'
    //     }, {
    //       name: 'Analitik & Laporan Dasar',
    //       desc: 'Akses laporan dan wawasan penjualan dasar untuk memantau pertumbuhan bisnis Anda.'
    //     }, {
    //       name: 'Akuisisi Pelanggan',
    //       desc: 'Jangkau dan tarik pelanggan baru melalui pengalaman pemesanan digital yang mudah dan menarik.'
    //     }, {
    //       name: 'Biaya Transaksi Rendah',
    //       desc: 'Nikmati keuntungan lebih besar dengan biaya transaksi yang lebih rendah di setiap pesanan.'
    //     }, {
    //       name: 'Dukungan melalui Email',
    //       desc: 'Dapatkan bantuan dan solusi cepat dari tim dukungan kami melalui email.'
    //     }],
    //     highlight: false,
    //     disc: 257040,
    //     price: 0,
    //     form: false
    //   }, {
    //     id: 2,
    //     name: 'SyncAI',
    //     suggest: '',
    //     desc: 'Pengalaman Terhubung dengan POS yang Mulus.',
    //     feature: [{
    //       name: 'Termasuk semua fitur <strong>LaunchAI</strong>',
    //       desc: 'Nikmati rangkaian lengkap alat pintar dari LaunchAI yang dirancang untuk meningkatkan kinerja restoran Anda.'
    //     }, {
    //       name: 'Sinkronisasi Pesanan POS & Menu Lite',
    //       desc: 'Jaga agar menu dan pesanan selalu selaras dengan sistem POS Anda untuk operasional yang lancar setiap hari.'
    //     }, {
    //       name: 'AI Booster – Rekomendasi Cross & Upsell',
    //       desc: 'Tingkatkan pendapatan dengan rekomendasi berbasis AI yang mendorong pelanggan menambah pesanan.'
    //     }, {
    //       name: 'Dasbor Analitik Standar',
    //       desc: 'Dapatkan wawasan berharga tentang tren penjualan dan perilaku pelanggan dengan tampilan data yang mudah dipahami.'
    //     }, {
    //       name: 'Loyalti Standar',
    //       desc: 'Bangun loyalitas pelanggan dengan fitur bawaan yang memberi penghargaan bagi pelanggan setia.'
    //     }, {
    //       name: 'Biaya Transaksi Lebih Rendah',
    //       desc: 'Nikmati keuntungan lebih besar dengan biaya transaksi yang lebih hemat di setiap pesanan.'
    //     }],
    //     highlight: true,
    //     disc: 899272,
    //     price: 642337,
    //     form: false
    //   }, {
    //     id: 3,
    //     name: 'EngageAI',
    //     suggest: '',
    //     desc: 'Keterlibatan Cerdas. Operasional Tanpa Hambatan.',
    //     feature: [{
    //       name: 'Termasuk semua fitur <strong>SyncAI</strong>',
    //       desc: 'Dapatkan semua alat canggih dari SyncAI untuk mendorong pertumbuhan dan efisiensi bisnis Anda.'
    //     }, {
    //       name: 'Pendaftaran Terkelola',
    //       desc: 'Nikmati proses setup yang lancar dengan panduan langsung dari tim ahli kami.'
    //     }, {
    //       name: 'Integrasi POS Penuh',
    //       desc: 'Hubungkan sistem POS Anda secara real-time untuk sinkronisasi menu, pesanan, dan pembayaran tanpa hambatan.'
    //     }, {
    //       name: 'AI Booster – Promosi',
    //       desc: 'Dorong penjualan dengan promosi otomatis yang disesuaikan berdasarkan perilaku pelanggan.'
    //     }, {
    //       name: 'AI Keterlibatan Ulang Pelanggan',
    //       desc: 'Raih kembali pelanggan lama dengan pendekatan cerdas dan personal berbasis data.'
    //     }, {
    //       name: 'Dasbor Analitik Lanjutan',
    //       desc: 'Buka wawasan mendalam melalui analitik komprehensif untuk strategi bisnis yang lebih kuat.'
    //     }, {
    //       name: 'Biaya Transaksi Paling Rendah',
    //       desc: 'Pertahankan margin keuntungan tertinggi dengan biaya transaksi paling kompetitif.'
    //     }, {
    //       name: 'Dukungan melalui WhatsApp',
    //       desc: 'Dapatkan bantuan cepat dan real-time langsung melalui WhatsApp.'
    //     }],
    //     highlight: false,
    //     disc: 2055896,
    //     price: 1798909,
    //     form: true
    //   }]
    // }, {
    //   name: 'MY',
      // fullName: 'Malaysia',
    //   flag: CountryFlagSvg['MY'],
    //   thousand: ',',
    //   decimal: '.',
    //   currency: 'MYR',
    //   scale: 2,
    //   fixed: true,
    //   lang: {
    //     //page: 'HARGA',
    //     title: 'Nilai yang Tumbuh Bersama Anda.',
    //     subtitle: 'Temui pelan harga yang direka untuk setiap peringkat perjalanan restoran anda, daripada pesanan pertama hingga kejayaan sepenuhnya.',
    //     month: 'Bulan',
    //     location: 'Kedai',
    //     start: 'Mulakan',
    //     contact: 'Hubungi Pasukan Kami',
    //     best: 'Paling Popular'
    //   },
    //   pricing: [{
    //     id: 1,
    //     name: 'LaunchAI',
    //     suggest: '',
    //     desc: 'Terus Aktif. Tanpa Kerumitan.',
    //     feature: [{
    //       name: 'Pendaftaran Sendiri',
    //       desc: 'Mulakan dengan cepat melalui proses persediaan yang mudah dan berpanduan—tanpa memerlukan bantuan teknikal.'
    //     }, {
    //       name: 'Pesanan & Pembayaran QR Berdiri Sendiri',
    //       desc: 'Benarkan pelanggan membuat pesanan dan pembayaran terus melalui kod QR, tanpa perlu disambungkan kepada sistem POS.'
    //     }, {
    //       name: 'Tiada AI Booster',
    //       desc: 'Pelan ini tidak merangkumi ciri AI seperti promosi automatik, penjualan tambahan, atau alat penglibatan pelanggan.'
    //     }, {
    //       name: 'Analitik & Laporan Asas',
    //       desc: 'Akses laporan asas dan pandangan penting tentang jualan serta prestasi perniagaan anda.'
    //     }, {
    //       name: 'Pemerolehan Pelanggan',
    //       desc: 'Tarik dan capai pelanggan baharu melalui pesanan digital dan ciri keterlihatan dalam talian.'
    //     }, {
    //       name: 'Yuran Transaksi Rendah',
    //       desc: 'Kekalkan lebih banyak keuntungan dengan kos transaksi yang lebih rendah bagi setiap pesanan.'
    //     }, {
    //       name: 'Sokongan melalui E-mel',
    //       desc: 'Dapatkan bantuan dan penyelesaian pantas daripada pasukan sokongan kami melalui e-mel.'
    //     }],
    //     highlight: false,
    //     disc: 63.5,
    //     price: 0,
    //     form: false
    //   }, {
    //     id: 2,
    //     name: 'SyncAI',
    //     suggest: '',
    //     desc: 'Pengalaman Dihubungkan dengan POS yang Lancar.',
    //     feature: [{
    //       name: 'Termasuk semua ciri <strong>LaunchAI</strong>',
    //       desc: 'Nikmati rangkaian penuh alat pintar daripada LaunchAI yang direka untuk meningkatkan prestasi restoran anda.'
    //     }, {
    //       name: 'Penyegerakan Pesanan POS & Menu Lite',
    //       desc: 'Pastikan menu dan pesanan anda sentiasa selaras dengan sistem POS untuk operasi harian yang lancar.'
    //     }, {
    //       name: 'AI Booster – Cadangan Silang & Upsell',
    //       desc: 'Tingkatkan hasil jualan dengan cadangan berasaskan AI yang menggalakkan pelanggan membuat pesanan tambahan.'
    //     }, {
    //       name: 'Papan Pemuka Analitik Standard',
    //       desc: 'Dapatkan pandangan bernilai tentang trend jualan dan tingkah laku pelanggan dengan paparan data yang mudah difahami.'
    //     }, {
    //       name: 'Loyalti Standard',
    //       desc: 'Kekalkan pelanggan dengan ciri ganjaran terbina yang menghargai kunjungan berulang.'
    //     }, {
    //       name: 'Yuran Transaksi Lebih Rendah',
    //       desc: 'Nikmati keuntungan lebih tinggi dengan yuran transaksi yang lebih rendah bagi setiap pesanan.'
    //     }],
    //     highlight: true,
    //     disc: 222.48,
    //     price: 158.91,
    //     form: false
    //   }, {
    //     id: 3,
    //     name: 'EngageAI',
    //     suggest: '',
    //     desc: 'Penglibatan Pintar. Operasi Tanpa Gangguan.',
    //     feature: [{
    //       name: 'Termasuk semua ciri <strong>SyncAI</strong>',
    //       desc: 'Dapatkan semua alat canggih daripada SyncAI untuk menggerakkan pertumbuhan dan kecekapan perniagaan anda.'
    //     }, {
    //       name: 'Pendaftaran Diurus',
    //       desc: 'Nikmati proses persediaan yang lancar dengan bimbingan terus daripada pasukan pakar kami.'
    //     }, {
    //       name: 'Integrasi POS Penuh',
    //       desc: 'Sambungkan sistem POS anda secara masa nyata untuk penyelarasan menu, pesanan dan pembayaran tanpa gangguan.'
    //     }, {
    //       name: 'AI Booster – Promosi',
    //       desc: 'Tingkatkan jualan dengan promosi automatik yang disesuaikan mengikut tingkah laku pelanggan.'
    //     }, {
    //       name: 'AI Penglibatan Semula Pelanggan',
    //       desc: 'Tarik semula pelanggan lama dengan pendekatan pintar dan peribadi berasaskan data.'
    //     }, {
    //       name: 'Papan Pemuka Analitik Lanjutan',
    //       desc: 'Dapatkan pandangan mendalam melalui analitik menyeluruh bagi strategi perniagaan yang lebih mantap.'
    //     }, {
    //       name: 'Yuran Transaksi Paling Rendah',
    //       desc: 'Maksimumkan keuntungan anda dengan kadar transaksi paling kompetitif.'
    //     }, {
    //       name: 'Sokongan melalui WhatsApp',
    //       desc: 'Terima bantuan segera dan kemas kini masa nyata terus melalui WhatsApp.'
    //     }],
    //     highlight: false,
    //     disc: 508.52,
    //     price: 444.9,
    //     form: true
    //   }]
    // }
    ];

    this.compare = [{
      name: 'Restaurant Operation',
      content: [{
        name: 'Manage Items and basic modifiers',
        desc: '',
        content: []
      }, {
        name: 'Manage Items availability',
        desc: '',
        content: []
      }, {
        name: 'Advanced modifiers',
        desc: '',
        content: []
      }, {
        name: 'Bulk edit items in menus',
        desc: '',
        content: []
      }, {
        name: 'Handle menu at brand level',
        desc: '',
        content: []
      }]
    }, {
      name: 'Customer Experience',
      content: [{
        name: 'Standard QR Ordering',
        desc: '',
        content: []
      }, {
        name: 'Increase Avg Bill value with AI',
        desc: '',
        content: []
      }, {
        name: 'Next Gen QR Ordering',
        desc: '',
        content: []
      }]
    }, {
      name: 'Third Party Integrations',
      content: [{
        name: 'Send Orders to POS',
        desc: '',
        content: []
      }, {
        name: 'Sync Menu Changes from POS',
        desc: '',
        content: []
      }, {
        name: 'Custom integration with POS',
        desc: '',
        content: []
      }, {
        name: 'Custom 3rd Part CRM Integration',
        desc: '',
        content: []
      }, {
        name: 'Delivery Partners Integration',
        desc: '',
        content: []
      }]
    }, {
      name: 'Payment',
      content: [{
        name: 'Payment Integration',
        desc: '',
        content: []
      }, {
        name: 'Lowest Transaction Fee',
        desc: '',
        content: []
      }, {
        name: 'Discounts and refunds',
        desc: '',
        content: []
      }]
    }, {
      name: 'Reporting & Analytics',
      content: [{
        name: 'Simple daily reports',
        desc: '',
        content: []
      }, {
        name: 'Outlet level insights',
        desc: '',
        content: []
      }, {
        name: 'Customer level insights',
        desc: '',
        content: []
      }]
    }, {
      name: 'Support',
      content: [{
        name: 'Email support',
        desc: ''
      }, {
        name: 'Live chat support',
        desc: ''
      }, {
        name: 'Dedicated Account Manager',
        desc: ''
      }]
    }];

    this.pipedriveCountry = [{
      value: '584', label: 'Singapore', code: 'SG'
    }, {
      value: '585', label: 'Malaysia', code: 'MY'
    }, {
      value: '586', label: 'Indonesia', code: 'ID'
    }, {
      value: '587', label: 'Australia', code: 'AU'
    }, {
      value: '588', label: 'Brunei', code: 'BN'
    }, {
      value: '589', label: 'Hong Kong', code: 'HK'
    }, {
      value: '590', label: 'Taiwan', code: 'TW'
    }, {
      value: '591', label: 'Thailand', code: 'TH'
    }, {
      value: '592', label: 'Philippines', code: 'PH'
    }, {
      value: '762', label: 'New Zealand', code: 'NZ'
    }, {
      value: '772', label: 'UK', code: 'GB'
    }, {
      value: '773', label: 'Sweden', code: 'SE'
    }, {
      value: '774', label: 'Brazil', code: 'BR'
    }, {
      value: '775', label: 'Poland', code: 'PL'
    }, {
      value: '826', label: 'Mexico', code: 'MX'
    }, {
      value: '834', label: 'Mauritius', code: 'MU'
    }, {
      value: '836', label: 'Dubai', code: 'AE'
    }, {
      value: '835', label: 'Cambodia', code: 'KH'
    }, {
      value: '1211', label: 'Others', code: ''
    }];
    
    this.titleRef = createRef();
    this.titleHeight = 0;
    this.compareRef = createRef();
    this.clientId = '';
    this.scrollNow = 0;
    this.utmSource = '';
    this.utmMedium = '';

    this.cancellableCountry = '';
    this.cancellableView = '';
    this.cancellableClick = '';
    this.cancellablePipedriveOrg = '';
    this.cancellablePipedrivePerson = '';
    this.cancellablePipedriveLead = '';
    this.cancellableEmail = '';
    this.cancellableLead = '';

    this.selectRegion = this.selectRegion.bind(this);
    this.clickAnalytics = this.clickAnalytics.bind(this);
    this.hoverAnalytics = this.hoverAnalytics.bind(this);
    this.togglePackage = this.togglePackage.bind(this);
    this.toggleCompare = this.toggleCompare.bind(this);
    // this.toggleFaq = this.toggleFaq.bind(this);
    this.sameHeight = this.sameHeight.bind(this);
    this.openPop = this.openPop.bind(this);
    this.closePop = this.closePop.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.selectChange = this.selectChange.bind(this);
    this.checkChange = this.checkChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.openNav = this.openNav.bind(this);
  }

  componentDidMount(){
    const param = this.props.router.search[0];

    this.utmSource = param.get('utm_source');
    this.utmMedium = param.get('utm_medium');

    if(typeof window.gtag === 'function'){
      window.gtag('get', 'G-0YN53XLX3Y', 'client_id', (clientId) => {
        this.clientId = clientId;
        
        this.cancellableView = makeCancellablePromise(
          addDoc(collection(db, 'event'), {
            eventClientId: clientId,
            eventName: 'view',
            eventPackage: null,
            eventRegion: this.region[0].name,
            eventSource: this.utmSource,
            eventMedium: this.utmMedium,
            eventTime: new Date(),
            eventActive: true,
            eventStatus: true,
          })
        );

        this.cancellableView.promise.then((querySnapshot) => {
          
        }).catch((error) => {
          console.error(error);

          toast.error(() => (<>{error.code}<span>{error.message}</span></>));
        });
      });
    }

    let listCode = [],
        listHighlight = []
    // ,
    //     listCountry = []
        ;

    CountryList.getAll().forEach((value, index) => {
      const theCode = {
        label: value.dial_code,
        value: value.code,
        name: value.name,
        flag: CountryFlagSvg[value.code]
      };

      if(this.country.findIndex(x => x.value === theCode.value) === -1){
        listCode.push(theCode);
      }

      if(this.region[0].name === value.code){
        this.setState({ code: theCode });
      }
    });

    this.country.forEach((value, index) => {
      const findDial = CountryList.findOneByCountryCode(value.value);

      listHighlight.push({
        label: findDial.data.dial_code,
        value: value.value,
        name: value.label,
        flag: value.flag
      });
    });

    this.setState({
      region: this.region[0],
      codeOption: [{
        label: 'Highlighted',
        options: listHighlight,
      }, {
        label: 'All Countries',
        options: listCode,
      }],
    });

    this.cancellableCountry = makeCancellablePromise(
      // fetch('https://ipapi.co/json/')
      fetch('https://api.country.is/')
    );

    this.cancellableCountry.promise.then((response) => {
      if(!response.ok){
        throw new Error('Network response was not ok');
      }
      return response.json();
    }).then((data) => {
      let findPipedrive = this.pipedriveCountry.find(x => x.code === data.country);
      
      if(typeof findPipedrive === 'undefined'){
        findPipedrive = this.pipedriveCountry.find(x => x.label === 'Others');
      }

      this.setState({
        country: data.country,
        pipedriveCountry: findPipedrive.value
      });

      const findHighlight = listHighlight.find(x => x.value === data.country),
            findCode = listCode.find(x => x.value === data.country);

      if(findHighlight || findCode){
        const theCode = findHighlight || findCode;

        this.setState({ code: theCode });
      }

      // this.setState({ load: false });
    }).catch((error) => {
      // this.setState({ load: false });

      console.error(error);

      toast.error(() => (<>{error.code}<span>{error.message}</span></>));
    });

    this.sameHeight();
    window.addEventListener('resize', this.sameHeight);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps, prevState){
    if(
      this.state.load !== prevState.load ||
      this.state.region !== prevState.region
    ){
      this.sameHeight();
    }

    if(this.state.name !== prevState.name){
      if(this.state.name !== ''){
        if(!this.state.nameInit){
          this.setState({ nameInit: true });
        }

        if(/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(this.state.name)){
          this.setState({ nameValid: true });
        }else{
          this.setState({ nameValid: 'Please enter a valid full name (at least 2 words).' });
        }
      }else{
        this.setState({ nameValid: 'Full name cannot be empty.' });
      }
    }

    if(this.state.email !== prevState.email){
      if(this.state.email !== ''){
        if(!this.state.emailInit){
          this.setState({ emailInit: true });
        }

        if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)){
          this.setState({ emailValid: true });
        }else{
          this.setState({ emailValid: 'Please enter a valid email address.' });
        }
      }else{
        this.setState({ emailValid: 'Email cannot be empty.' });
      }
    }

    if(
      this.state.code !== prevState.code ||
      this.state.phone !== prevState.phone
    ){
      if(this.state.code !== null && this.state.phone !== ''){
        if(!this.state.phoneInit){
          this.setState({ phoneInit: true });
        }

        const phone = `${this.state.code.label}${this.state.phone}`,
                        parse = parsePhoneNumber(phone),
                        isValid = parse ? isValidPhoneNumber(parse.number, this.state.code.code) : isValidPhoneNumber(phone, this.state.code.code),
                        isPossible = parse ? isPossiblePhoneNumber(parse.number, this.state.code.code) : isPossiblePhoneNumber(phone, this.state.code.code);

        if(isValid && isPossible){
          this.setState({
            phoneFull: parse.number,
            phoneValid: true
          });
        }else{
          const validate = validatePhoneNumberLength(this.state.phone, this.state.code.code);

          if(validate === 'TOO_SHORT'){
            this.setState({
              phoneFull: '',
              phoneValid: 'Phone number is too short.'
            });
          }else if(validate === 'TOO_LONG'){
            this.setState({
              phoneFull: '',
              phoneValid: 'Phone number is too long.'
            });
          }else{
            this.setState({
              phoneFull: '',
              phoneValid: 'Please enter a valid phone number.'
            });
          }
        }
      }else{
        this.setState({
          phoneFull: '',
          phoneValid: 'Phone number cannot be empty.'
        });
      }
    }

    if(this.state.restaurant !== prevState.restaurant){
      if(this.state.restaurant !== ''){
        if(!this.state.restaurantInit){
          this.setState({ restaurantInit: true });
        }

        if(/^[A-Za-z0-9 .,&'-]{2,}$/.test(this.state.restaurant)){
          this.setState({ restaurantValid: true });
        }else{
          this.setState({ restaurantValid: 'Please enter a valid restaurant name.' });
        }
      }else{
        this.setState({ restaurantValid: 'Restaurant name cannot be empty.' });
      }
    }

    if(this.state.agree !== prevState.agree){
      if(this.state.agree){
        if(!this.state.agreeInit){
          this.setState({ agreeInit: true });
        }

        this.setState({ agreeValid: true });
      }else{
        this.setState({ agreeValid: 'You must agree to the Privacy Policy and consent to TabSquare using your information before submitting the form.' });
      }
    }

    if(
      this.state.nameValid !== prevState.nameValid ||
      this.state.emailValid !== prevState.emailValid ||
      this.state.phoneValid !== prevState.phoneValid ||
      this.state.restaurantValid !== prevState.restaurantValid ||
      this.state.agreeValid !== prevState.agreeValid
    ){
      if(
        this.state.nameValid === true &&
        this.state.emailValid === true &&
        this.state.phoneValid === true &&
        this.state.restaurantValid === true &&
        this.state.agreeValid === true
      ){
        this.setState({ formValid: true });
      }else{
        this.setState({ formValid: false });
      }
    }
  }

  componentWillUnmount(){
    if(this.cancellableView){
      this.cancellableView.cancel();
    }

    if(this.cancellableCountry){
      this.cancellableCountry.cancel();
    }

    if(this.cancellableClick){
      this.cancellableClick.cancel();
    }

    if(this.cancellablePipedriveOrg){
      this.cancellablePipedriveOrg.cancel();
    }

    if(this.cancellablePipedrivePerson){
      this.cancellablePipedrivePerson.cancel();
    }

    if(this.cancellablePipedriveLead){
      this.cancellablePipedriveLead.cancel();
    }

    if(this.cancellableEmail){
      this.cancellableEmail.cancel();
    }

    if(this.cancellableLead){
      this.cancellableLead.cancel();
    }

    window.removeEventListener('resize', this.sameHeight);
    window.removeEventListener('scroll', this.handleScroll);
  }

  selectRegion(event){
    this.setState({ region: this.region.find(x => x.name === event.target.name) });
  }

  clickAnalytics(event){
    event.preventDefault();

    if(typeof window.gtag === 'function'){
      window.gtag('event', 'button_click', {
        package: event.target.name,
        region: this.state.region.name
      });
    }
    
    const findPackage = this.state.region.pricing.find(x => x.name === event.target.name);

    if(typeof findPackage !== 'undefined' && findPackage.form){
      this.openPop(event.target.name);
    }else{
      window.open(event.target.href, '_blank');
    }

    this.cancellableClick = makeCancellablePromise(
      addDoc(collection(db, 'event'), {
        eventClientId: this.clientId,
        eventName: 'button_click',
        eventPackage: event.target.name,
        eventRegion: this.state.region.name,
        eventSource: this.utmSource,
        eventMedium: this.utmMedium,
        eventTime: new Date(),
        eventActive: true,
        eventStatus: true,
      })
    );

    this.cancellableClick.promise.then((querySnapshot) => {
      
    }).catch((error) => {
      console.error(error);

      toast.error(() => (<>{error.code}<span>{error.message}</span></>));
    });
  }

  hoverAnalytics(event){
    if(typeof window.gtag === 'function'){
      window.gtag('event', 'package_hover', {
        package: event.target.dataset.name,
        region: this.state.region.name
      });
    }
  }

  togglePackage(event){
    let region = this.state.region;

    region.pricing[event.target.name].open = !region.pricing[event.target.name].open;

    this.setState({ region: region });
  }

  toggleCompare(){
    this.titleHeight = this.titleRef.current.clientHeight;

    this.setState({ compareOpen: !this.state.compareOpen });
  }
  
  // toggleFaq(event){
  //   let listFaq = [...this.state.faq];

  //   listFaq[event.target.name].open = !listFaq[event.target.name].open;

  //   this.setState({ faq: listFaq });
  // }
  
  sameHeight(){
    let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    if(!this.state.load && this.state.region && vw > 767){
      const elementCard = document.getElementsByClassName('package'),
            elementName = document.getElementsByClassName('name'),
            elementSuggest = document.getElementsByClassName('suggest'),
            elementPrice = document.getElementsByClassName('price');

      let highCard = '',
          highName = '',
          highSuggest = '',
          highPrice = '';
      
      for(let i = 0; i < elementCard.length; i++){
        if(i === 0){
          highCard = elementCard[i].firstElementChild.offsetHeight;
        }else{
          if(highCard < elementCard[i].firstElementChild.offsetHeight){
            highCard = elementCard[i].firstElementChild.offsetHeight;
          }
        }
      }

      for(let i = 0; i < elementName.length; i++){
        if(i === 0){
          highName = elementName[i].firstElementChild.offsetHeight;
        }else{
          if(highName < elementName[i].firstElementChild.offsetHeight){
            highName = elementName[i].firstElementChild.offsetHeight;
          }
        }
      }

      for(let i = 0; i < elementSuggest.length; i++){
        if(i === 0){
          highSuggest = elementSuggest[i].firstElementChild.offsetHeight;
        }else{
          if(highSuggest < elementSuggest[i].firstElementChild.offsetHeight){
            highSuggest = elementSuggest[i].firstElementChild.offsetHeight;
          }
        }
      }

      for(let i = 0; i < elementPrice.length; i++){
        if(i === 0){
          highPrice = elementPrice[i].firstElementChild.offsetHeight;
        }else{
          if(highPrice < elementPrice[i].firstElementChild.offsetHeight){
            highPrice = elementPrice[i].firstElementChild.offsetHeight;
          }
        }
      }

      this.setState({
        height: {
          card: highCard + 30,
          name: highName,
          suggest: highSuggest,
          price: highPrice
        }
      });
    }else{
      this.setState({
        height: {
          card: '',
          name: '',
          suggest: '',
          price: ''
        }
      });
    }
  }

  openPop(pack){
    this.setState({ popOpen: pack });
  }

  closePop(){
    this.setState({ popOpen: '' });

    if(this.state.formSuccess){
      this.setState({ formSuccess: false });
    }
  }

  inputChange(event){
    if(event.target.name === 'email' && event.target.value){
      this.setState({ [event.target.name]: event.target.value.toLowerCase() });
    }else{
      this.setState({ [event.target.name]: event.target.value });
    }
  }

  selectChange(value, event){
    this.setState({ [event.name]: value });
  }

  checkChange(event){
    this.setState({ [event.target.name]: !this.state[event.target.name] });
  }

  formSubmit(event){
    event.preventDefault();

    if(this.state.formValid){
      this.setState({ formLoad: true });

      this.cancellablePipedriveOrg = makeCancellablePromise(
        fetch(`${process.env.REACT_APP_PIPEDRIVE_URL}api/v2/organizations?api_token=${process.env.REACT_APP_PIPEDRIVE_TOKEN}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: this.state.restaurant,
            // name: 'Product Team Test',
            // owner_id: '',
            // add_time: '',
            // update_time: '',
            // visible_to: '',
            // label_ids: '',
            // address: '',

          })
        })
      );

      this.cancellablePipedriveOrg.promise.then((responsePipedrive) => {
        if(!responsePipedrive.ok){
          throw new Error('Network response was not ok');
        }
        
        return responsePipedrive.json();
      }).then((responsePipedriveOrg) => {
        // console.log(responsePipedriveOrg);

        if(responsePipedriveOrg.success === true){
          this.cancellablePipedrivePerson = makeCancellablePromise(
            fetch(`${process.env.REACT_APP_PIPEDRIVE_URL}api/v2/persons?api_token=${process.env.REACT_APP_PIPEDRIVE_TOKEN}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                name: this.state.name,
                // name: 'TS Cafe Test',
                // owner_id: '',
                org_id: responsePipedriveOrg.data.id,
                // add_time: '',
                // update_time: '',
                emails: [{
                  value: this.state.email,
                  label: 'work',
                  primary: true
                }],
                // emails: [{
                //   value: 'tscafe@tabsquare.com',
                //   label: 'work',
                //   primary: true
                // }],
                phones: [{
                  value: this.state.phoneFull,
                  label: 'mobile',
                  primary: true
                }],
                // phones: [{
                //   value: '+6512345678910',
                //   label: 'mobile',
                //   primary: true
                // }],
                // visible_to: '',
                // label_ids: '',
                // marketing_status: '',
              })
            })
          );

          this.cancellablePipedrivePerson.promise.then((responsePipedrive) => {
            if(!responsePipedrive.ok){
              throw new Error('Network response was not ok');
            }
            
            return responsePipedrive.json();
          }).then((responsePipedrivePerson) => {
            // console.log(responsePipedrivePerson);

            if(responsePipedrivePerson.success === true){
              const findLabel = this.state.region.pricing.find(x => x.name === this.state.popOpen);
              
              this.cancellablePipedriveLead = makeCancellablePromise(
                fetch(`${process.env.REACT_APP_PIPEDRIVE_URL}api/v1/leads?api_token=${process.env.REACT_APP_PIPEDRIVE_TOKEN}`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    title: `${this.state.restaurant} lead`,
                    // title: `TS Cafe lead test`,
                    person_id: responsePipedrivePerson.data.id,
                    organization_id: responsePipedriveOrg.data.id,
                    label_ids: [findLabel.pipedriveId],
                    '7216962232207f947f98fb9039509bc449551ab9': this.state.pipedriveCountry,
                    'cb341c06aaf891c52fa819a45bad2cd9df2f1b9b': this.utmSource,
                    'c97d533d09ebffda56ab0e6c4c317289f892fd30': this.utmMedium
                    
                    // product_name: this.state.popOpen,
                    // product_name: 'Industry Leader',
                    // custom_fields: {
                    // '7216962232207f947f98fb9039509bc449551ab9': this.state.region.name
                    // '7216962232207f947f98fb9039509bc449551ab9': 'SG'
                  //   email_field: email,
                  //   message_field: message,
                    // },
                  })
                })
              );

              this.cancellablePipedriveLead.promise.then((responsePipedrive) => {
                if(!responsePipedrive.ok){
                  throw new Error('Network response was not ok');
                }

                return responsePipedrive.json();
              }).then((responsePipedriveLead) => {
                if(responsePipedriveLead.success === true){
                  this.cancellableToken = makeCancellablePromise(
                    fetch(`${process.env.REACT_APP_TS_BASE_URL}api/v1/otp/token`, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                        merchant_key: process.env.REACT_APP_TS_MERCHANT_KEY
                      })
                    })
                  );
          
                  this.cancellableToken.promise.then(responseToken => {
                    // console.log('response token 1', responseToken);
          
                    if(!responseToken.ok){
                      throw new Error(`HTTP error! status: ${responseToken.status}`);
                    }
          
                    return responseToken.json();
                  }).then((responseToken) => {
                    // console.log('response token 2', responseToken);
          
                    if(responseToken.success){
                      let source = '';

                      if(this.utmSource){
                        if(this.utmMedium){
                          source = `${this.utmSource}/${this.utmMedium}`;
                        }else{
                          source = `${this.utmSource}/-`;
                        }
                      }else{
                        if(this.utmMedium){
                          source = `-/${this.utmMedium}`;
                        }
                      }

                      this.cancellableEmail = makeCancellablePromise(
                        fetch(`${process.env.REACT_APP_TS_BASE_URL}api/v1/merchant/${process.env.REACT_APP_TS_MERCHANT_KEY}/lead/generation/email`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${responseToken.accessToken}`,
                          },
                          body: JSON.stringify({
                            restro_name: this.state.restaurant,
                            user_name: this.state.name,
                            email: this.state.email,
                            phone: this.state.phoneFull,
                            package_name: this.state.popOpen,
                            location: '',
                            social_media: '',
                            country: this.state.country,
                            lead_from: 'smartpackage_lead',
                            lead_source: source,
                            time: (new Date()).toISOString()
                          })
                        })
                      );

                      this.cancellableEmail.promise.then((responseEmail) => {
                        if(!responseEmail.ok){
                          throw new Error('Network response was not ok');
                        }

                        return responseEmail.json();
                      }).then((responseEmail) => {
                        if(responseEmail.success){
                          this.cancellableLead = makeCancellablePromise(
                            addDoc(collection(db, 'lead'), {
                              leadClientId: this.clientId,
                              leadPackage: {
                                leadPackageRef: null,
                                leadPackageName: this.state.popOpen
                              },
                              leadName: this.state.name,
                              leadEmail: this.state.email,
                              leadPhone: {
                                leadPhoneCode: this.state.code.label,
                                leadPhoneNumber: this.state.phone,
                              },
                              leadRestaurant: this.state.restaurant,
                              leadCountry: this.state.country,
                              leadRegion: this.state.region.name,
                              leadTime: new Date(),
                              leadActive: true,
                              leadStatus: true,
                            })
                          );

                          this.cancellableLead.promise.then((querySnapshot) => {
                            
                          }).catch((error) => {
                            console.error(error);

                            toast.error(() => (<>{error.code}<span>{error.message}</span></>));
                          });
                          
                          this.setState({
                            formLoad: false,
                            formSuccess: true,
                          });
                        }else{
                          this.setState({ formLoad: false });
                        }
                      }).catch((error) => {
                        console.error(error);

                        toast.error(() => (<>{error.code}<span>{error.message}</span></>));

                        this.setState({ formLoad: false });
                      });
                    }else{
                      toast.error(() => (<>{responseToken.error_code}<span>{responseToken.message}</span></>));
                    }
                  }).catch((error) => {
                    console.error(error);
          
                    toast.error(() => (<>{error.code}<span>{error.message}</span></>));

                    this.setState({ formLoad: false });
                  });
                }else{
                  this.setState({ formLoad: false });
                }
              }).catch((error) => {
                console.error(error);

                toast.error(() => (<>{error.code}<span>{error.message}</span></>));

                this.setState({ formLoad: false });
              });
            }else{
              this.setState({ formLoad: false });
            }
          }).catch((error) => {
            console.error(error);

            toast.error(() => (<>{error.code}<span>{error.message}</span></>));

            this.setState({ formLoad: false });
          });
        }else{
          this.setState({ formLoad: false });
        }
      }).catch((error) => {
        console.error(error);

        toast.error(() => (<>{error.code}<span>{error.message}</span></>));

        this.setState({ formLoad: false });
      });

      // {
      //   clientId: this.clientId,
      //   name: this.state.name,
      //   email: this.state.email,
      //   phone: this.state.phoneFull,
      //   restaurant: this.state.restaurant,
      //   region: this.state.region.name,
      //   package: event.target.name,
      //   Time: new Date(),
      //   // eventActive: true,
      //   // eventStatus: true,
      // }

      // this.setState({ formLoad: true });
      
      // console.log(`clientId: ${this.clientId}\nname: ${this.state.name}\nemail: ${this.state.email}\nphone: ${this.state.phoneFull}\nrestaurant: ${this.state.restaurant}\nregion: ${this.state.region.name}\npackage: ${this.state.popOpen}\nTime: ${new Date()}`);

      // setTimeout(() => {
      //   this.setState({
      //     formLoad: false,
      //     formSuccess: true,
      //   });
      // }, 2000);
    }else{
      this.setState({
        nameInit: true,
        emailInit: true,
        phoneInit: true,
        restaurantInit: true,
        agreeInit: true
      });
    }
  }

  handleScroll(){
    if(this.state.compareOpen){
      if((this.compareRef.current.getBoundingClientRect().top - 66) < 0 && (this.compareRef.current.getBoundingClientRect().bottom - 66 - this.titleHeight) > 0){
        if(this.state.compareFloating === false){
          this.setState({ compareFloating: true });
        }
      }else{
        if(this.state.compareFloating === true){
          this.setState({ compareFloating: false });
        }
      }
    }

    if(window.scrollY < 66 || this.scrollNow > window.scrollY){
      if(this.state.header === false){
        this.setState({ header: true });
      }
    }else{
      if(this.state.header === true){
        this.setState({ header: false });
      }

      if(this.state.nav === true){
        this.setState({ nav: false });
      }
    }

    this.scrollNow = window.scrollY;
  }

  openNav(){
    this.setState({ nav: !this.state.nav })
  }

  formatOptionLabel = ({ label, name, flag }) => (
    <div className="code-option">
      <div className="flag" dangerouslySetInnerHTML={{ __html: flag }}></div>
      <div className="country">{name}</div>
      <div className="code">{label}</div>
    </div>
    // <ul className="floating lite">
    //   <li className="lay-60">
        
    //     {name}
    //   </li>
    //   <li className="lay-40">
    //     {label}
    //   </li>
    // </ul>
  );

  render(){
    // const customOption = ({ label, name }) => (
    //   <>
    //     {name} {label}
    //   </>
    // );

    return(
      <>
        {/* <Tooltip id="package-tooltip" openOnClick /> */}
        <Tooltip id="package-tooltip" />
        <Tooltip id="compare-tooltip" />

        <header className={`${this.state.header ? '' : this.state.compareFloating ? '' : 'hide'} ${this.state.nav ? '' : 'mobile-hide'}`}>
          <section>
            <a href="https://tabsquare.ai">
              <LogoTsNormal />
            </a>
            <ul>
              <li>
                <a href="https://tabsquare.ai/solutions-munchmate/">Solutions</a>
              </li>
              <li>
                <a href="https://tabsquare.ai/integrations/">Integrations</a>
              </li>
              <li>
                <Link href="/" className="active">Pricing</Link>
              </li>
              <li>
                <a href="https://tabsquare.ai/blog/">Resources</a>
                <ul>
                  <li>
                    <a href="https://tabsquare.ai/blog/">Blog</a>
                  </li>
                  <li>
                    <a href="https://tools.tabsquare.ai/review">Free Tools</a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="https://tabsquare.ai/about-us/">About Us</a>
              </li>
              <li>
                <a href="https://tabsquare.ai/support/" className="as-button">Support</a>
              </li>
              <li>
                <a href="https://ecms.tabsquare.com/login" className="as-button">Sign In</a>
              </li>
            </ul>
            <button type="button" onClick={this.openNav}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </section>
        </header>

        <div className="pad-top"></div>

        <div className="content">
            {this.state.load ? (
              <section>
                <div className="loading">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 2.81893V15.1811C0 15.9287 0.290574 16.6457 0.807793 17.1744C1.32501 17.703 2.0265 18 2.75796 18H7.23336V9.46887H3.37335V6.87294H14.2541V9.46887H10.3997V17.9943H14.8751C15.6066 17.9943 16.3081 17.6973 16.8253 17.1686C17.3425 16.64 17.6331 15.923 17.6331 15.1753V2.81893C17.6331 2.0713 17.3425 1.35429 16.8253 0.825641C16.3081 0.296989 15.6066 0 14.8751 0H2.75796C2.0265 0 1.32501 0.296989 0.807793 0.825641C0.290574 1.35429 0 2.0713 0 2.81893V2.81893Z" fill="#FF6B00" className="the-bg" />
                    <path d="M3.3623 6.87305H14.2431V9.46898H10.3887V17.9944H7.21674L7.22234 9.46898H3.3623V6.87305Z" fill="white" className="the-t" />
                  </svg>
                  Please Wait...
                </div>
              </section>
            ) : this.state.region ? (
              <>
                <div className="section-pricing">
                  <section>
                    <div className="title">
                      {/* <span>{this.state.region.lang.page}</span> */}
                      <h1>{this.state.region.lang.title}</h1>
                      {this.state.region.lang.subtitle}
                    </div>

                    <ul className="floating mid pricing">
                      {this.state.region.pricing.map((value, index) => (
                        <li key={value.id} className={`lay-${this.state.region.pricing.length === 3 ? '333' : 100 / this.state.region.pricing.length}`}>
                          <div className={`package ${value.highlight ? 'high' : ''}`} onMouseEnter={this.hoverAnalytics} data-name={value.name} style={{ minHeight: this.state.height.card ? `${this.state.height.card}px` : undefined }}>
                            <ul>
                              {/* <li className="icon">
                                <div>
                                  <img src={require(`./../../assets/img/icon-package-${index + 1}.png`)} alt={value.name} />
                                </div>
                              </li> */}
                              <li className="name" style={{ minHeight: this.state.height.name ? `${this.state.height.name}px` : undefined }}>
                                <div>
                                  {value.name}
                                  {value.highlight ? (<div>{this.state.region.lang.best}</div>) : ''}
                                </div>
                              </li>
                              <li className="suggest" style={{ minHeight: this.state.height.suggest ? `${this.state.height.suggest}px` : undefined }}>
                                <div>{value.suggest}</div>
                              </li>
                              <li className="price" style={{ minHeight: this.state.height.price ? `${this.state.height.price}px` : undefined }}>
                                <div>
                                  {value.disc !== '' ? (<span><NumericFormat value={value.disc} displayType="text" prefix={`${this.state.region.currency} `} thousandSeparator={this.state.region.thousand} decimalSeparator={this.state.region.decimal} decimalScale={this.state.region.scale} fixedDecimalScale={this.state.region.fixed} renderText={(value) => <strong>{value}</strong>} /></span>) : ''}
                                  {value.price !== '' ? (<NumericFormat value={value.price} displayType="text" prefix={`${this.state.region.currency} `} thousandSeparator={this.state.region.thousand} decimalSeparator={this.state.region.decimal} decimalScale={this.state.region.scale} fixedDecimalScale={this.state.region.fixed} renderText={(value) => value} />) : 'Custom'}
                                  {value.price !== '' ? (<div className="month">/{this.state.region.lang.month}</div>) : ''}
                                  <div className={`location ${value.price === '' ? 'empty' : ''}`}>{value.price !== '' ? (<>per {this.state.region.lang.location}</>) : (<>&nbsp;</>)}</div>
                                </div>
                              </li>
                              <li className="act">
                                {/* <button type="button" onClick={this.clickAnalytics} name={value.name} className={`btn ${value.highlight ? '' : 'btn-invert'}`}>
                                  {index === 0 || index === 1 ? this.state.region.lang.start : this.state.region.lang.contact}
                                </button> */}
                                {value.form ? (
                                  <button type="button" onClick={this.clickAnalytics} name={value.name} className={`btn ${value.highlight ? '' : 'btn-invert'}`}>
                                    {this.state.region.lang.contact}
                                  </button>
                                ) : (
                                  <a href={`https://portal.tabsquare.com/register?region=${this.state.region.name.toLowerCase()}&package=${value.slug.toUpperCase()}`} onClick={this.clickAnalytics} name={value.name} className={`btn ${value.highlight ? '' : 'btn-invert'}`}>
                                    {this.state.region.lang.start}
                                  </a>
                                )}
                              </li>
                              <li className="desc" dangerouslySetInnerHTML={{ __html: value.desc }}></li>
                              <li className={`feat ${value.open ? 'show' : ''}`}>
                                <button type="button" onClick={this.togglePackage} name={index}>
                                  Details<IconPlus />
                                </button>
                                <div>
                                  {value.feature[0].name ? (<div>{value.feature[0].name}</div>) : ''}
                                  <ul>
                                    {value.feature.map((valFeat, indFeat) => indFeat > 0 ? (
                                      <li key={`${value.id}-${indFeat}`} data-tooltip-id={valFeat.desc ? 'package-tooltip' : undefined} data-tooltip-content={valFeat.desc ? valFeat.desc : undefined}>
                                        <span><IconCheck /></span>
                                        <div dangerouslySetInnerHTML={{ __html: valFeat.name }}></div>
                                      </li>
                                    ) : '')}
                                  </ul>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </section>
                </div>
                
                <section className={`section-compare ${this.state.compareOpen ? 'show' : ''}`}>
                  <button type="button" className="btn btn-netral" onClick={this.toggleCompare}>Compare Plans<IconChev /></button>
                  <ul className={this.state.compareFloating ? 'float' : ''} ref={this.compareRef}>
                    <li ref={this.titleRef}>
                      <ul>
                        <li>
                          <div>&nbsp;</div>
                          <ul className="floating">
                              {this.state.region.pricing.map((valPack, indPack) => (
                                <li key={`float-head-${indPack}`} className={`lay-${this.state.region.pricing.length === 3 ? '333' : 100 / this.state.region.pricing.length}`}>
                                  {valPack.name}
                                </li>
                              ))}
                            </ul>
                        </li>
                      </ul>
                    </li>
                    {this.compare.map((value, index) => (
                      <li key={`compare-${index}`}>
                        <div>{value.name}</div>
                        <ul>
                          {value.content.map((valCon, indCon) => (
                            <li key={`compare-${index}-${indCon}`}>
                              <div>
                                {valCon.name}{valCon.desc ? (<IconInfo data-tooltip-id="compare-tooltip" data-tooltip-content={valCon.desc} />) : ''}
                              </div>
                              <ul className="floating">
                                {this.state.region.pricing.map((valPack, indPack) => (
                                  <li key={`float-child-${indPack}`} className={`lay-${this.state.region.pricing.length === 3 ? '333' : 100 / this.state.region.pricing.length}`}>
                                    {
                                      typeof valPack.compare[index] !== 'undefined' ?
                                      typeof valPack.compare[index][indCon] === 'boolean' ?
                                      valPack.compare[index][indCon] === true ? (<IconCheck />) :
                                      (<IconPlus className="disabled" />) :
                                      typeof valPack.compare[index][indCon] === 'object' ?
                                      (
                                        <>
                                          <img src={valPack.compare[index][indCon].img} alt={valPack.compare[index][indCon].name} />
                                          {valPack.compare[index][indCon].name}
                                        </>
                                      ) :
                                      valPack.compare[index][indCon] :
                                      ''
                                    }
                                  </li>
                                ))}
                              </ul>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </section>

                {/* <section>
                  <ul className="floating faq">
                    <li className="lay-40">
                      <div className="title text-left">
                        <h2>FAQ</h2>
                      </div>
                    </li>
                    <li className="lay-60">
                      <ul className="floating mid faq-list">
                        {this.state.faq.map((value, index) => (
                          <li key={`faq-${index}`}>
                            <button type="button" className={value.open ? 'show' : ''} onClick={this.toggleFaq} name={index}>
                              <div className="question">{value.question}<IconPlus /></div>
                              <div className="answer" dangerouslySetInnerHTML={{ __html: value.answer }}></div>
                            </button>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </section> */}

                <Popup open={this.state.popOpen !== ''} className={this.state.formSuccess ? 'pop-success' : ''} closeOnDocumentClick={false} lockScroll onClose={this.closePop}>
                  <button type="button" onClick={this.closePop}><IconPlus /></button>
                  <form onSubmit={this.formSubmit}>
                    {/* <div className="pop-head">Talk to Our Team</div> */}
                    <ul className="floating big">
                      {this.state.formSuccess ? (
                        <li>
                          <div className="pop-title">
                            <img src={require(`./../../assets/img/congrats.webp`)} alt="We’ve received your request" />
                            <h2>We’ve received your <span>request</span></h2>
                            Our specialist will review your details and contact you within one business day to discuss your custom solution.
                          </div>
                        </li>
                      ) : (
                        <>
                          <li className="lay-50">
                            <div className="pop-title">
                              <h2>Let’s <span>Unlock Your Full Potential</span> with us!</h2>
                              Complete the form, and we'll connect you with a specialist to walk you through the best plan for your business.
                            </div>
                          </li>
                          <li className="lay-50">
                            <ul className="floating forming">
                              <li>
                                <FormInput
                                  type="text"
                                  label="Full Name"
                                  name="name"
                                  placeholder="Type your full name"
                                  value={this.state.name}
                                  init={this.state.nameInit}
                                  valid={this.state.nameValid}
                                  onChange={this.inputChange}
                                  disabled={this.state.formLoad}
                                  required
                                  autoFocus
                                />
                              </li>
                              <li>
                                <FormInput
                                  type="email"
                                  label="Email"
                                  name="email"
                                  placeholder="Type your email address"
                                  value={this.state.email}
                                  init={this.state.emailInit}
                                  valid={this.state.emailValid}
                                  onChange={this.inputChange}
                                  disabled={this.state.formLoad}
                                  required
                                />
                              </li>
                              <li>
                                <label className={`label-input focus ${this.state.phoneInit && this.state.phoneValid !== true ? 'error' : ''}`}>Phone Number <span>*</span></label>
                                <ul className="form-phone">
                                  <li>
                                    <FormSelect
                                      name="code"
                                      value={this.state.code}
                                      options={this.state.codeOption}
                                      onChange={this.selectChange}
                                      // components={{ Option: customOption }}
                                      filterOption={(options, filterString) => {
                                        const labelLower = options.label.toLowerCase(),
                                              countryLower = options.data.name.toLowerCase(),
                                              filterLower = filterString.toLowerCase();
                                        
                                        return labelLower.includes(filterLower) || countryLower.includes(filterLower);
                                      }}
                                      formatOptionLabel={this.formatOptionLabel}
                                      disabled={this.state.formLoad}
                                    />
                                  </li>
                                  <li>
                                    <FormInput
                                      type="number"
                                      name="phone"
                                      placeholder="Type your phone number"
                                      value={this.state.phone}
                                      className={this.state.phoneInit && this.state.phoneValid !== true ? 'error' : ''}
                                      // init={this.state.phoneInit}
                                      // valid={this.state.phoneValid}
                                      onChange={this.inputChange}
                                      disabled={this.state.formLoad}
                                    />
                                  </li>
                                </ul>
                                <div className={`error-msg ${this.state.phoneInit && this.state.phoneValid !== true ? 'error-show' : ''}`}>{this.state.phoneValid}</div>
                              </li>
                              <li>
                                <FormInput
                                  type="text"
                                  label="Restaurant Name"
                                  name="restaurant"
                                  placeholder="Type your restaurant name"
                                  value={this.state.restaurant}
                                  init={this.state.restaurantInit}
                                  valid={this.state.restaurantValid}
                                  onChange={this.inputChange}
                                  disabled={this.state.formLoad}
                                  required
                                />
                              </li>
                              {/* <li className="lay-50">
                                <FormSelect
                                  label="Country"
                                  name="country"
                                  placeholder="Type your country"
                                  value={this.state.country}
                                  options={this.state.countryOption}
                                  onChange={this.selectChange}
                                  formatOptionLabel={formatFlag}
                                  required
                                />
                              </li> */}
                              <li>
                                <label>
                                  <input type="checkbox" name="agree" onChange={this.checkChange} checked={this.state.agree} disabled={this.state.formLoad} />
                                  <div className="checkbox"><IconCheck /></div>
                                  I agree to the <a href="https://tabsquare.ai/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a> and consent to TabSquare using your information to look into and respond to your inquiry.
                                </label>
                                <div className={`error-msg ${this.state.agreeInit && this.state.agreeValid !== true ? 'error-show' : ''}`}>{this.state.agreeValid}</div>
                              </li>
                              <li>
                                <button type="submit" className="btn" disabled={this.state.formLoad}>
                                  {this.state.formLoad ? 'Submiting...' : 'Submit'}
                                </button>
                              </li>
                            </ul>
                          </li>
                        </>
                      )}
                    </ul>
                    {/* <div className="pop-foot">
                      <ul className="floating forming">
                        <li>
                          <button type="submit" className="btn">
                            Submit
                          </button>
                        </li>
                      </ul>
                    </div> */}
                  </form>
                </Popup>
              </>
            ) : (
              <section>
                <div className="choose">
                  <div className="title">
                    <h1>This site doesn't match your location.</h1>
                    Please choose your location first, where you'll get regional content, offerings and pricing.
                  </div>
                  <ul className="floating">
                    {this.country.map((value, index) => (
                      <li key={value.value} className="lay-666">
                        <button type="button" disabled={!value.status} name={value.value} onClick={this.selectRegion}>
                          <div dangerouslySetInnerHTML={{ __html: value.flag }}></div>
                          {value.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </section>
            )}
        </div>
        
        <footer>
          <section>
            <ul className="floating">
              <li className="lay-50">
                <ul>
                  <li>
                    <a href="https://tabsquare.ai/privacy-policy/" target="_blank" rel="noreferrer" className="normal">Privacy Policy</a>
                  </li>
                  <li className="separate">&bull;</li>
                  <li>
                    <Link href="/">SmartPackages</Link> by <a href="https://tabsquare.ai/" target="_blank" rel="noreferrer">TabSquare.ai</a> © All rights reserved.
                  </li>
                </ul>
              </li>
              <li className="lay-50">
                <a href="https://tabsquare.ai/" target="_blank" rel="noreferrer">
                  <LogoTsWhite /><br />
                  Building The Future of Restaurant
                </a>
              </li>
            </ul>
          </section>
        </footer>
      </>
    );
  }
}

export default withRouter(Homepage);